import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActionDisplayResponse} from '../../../_models/action.model';
import {GenericPayloadModel, GenericPayloadType, PayloadColumnDefinitions} from '@cas-hub/acabim-common-client';
import {ActionService} from '../../../_services/action.service';

@Component({
  selector: 'acabim-admin-action-archive',
  templateUrl: './action-archive.component.html',
  styleUrls: ['./action-archive.component.scss']
})
export class ActionArchiveComponent implements OnInit {

  actionInfo: {payload: GenericPayloadModel[], meta: PayloadColumnDefinitions[]} | null = null;
  done = false;
  parcel: number[] = [];
  selectedActions: ActionDisplayResponse[] = [];

  @Input() set setDetails(value:  ActionDisplayResponse[]) {
    this.done = false;
    console.dir(value);
    this.selectedActions = value;
    this.actionInfo = {
      meta: [
        {
          columnNumber: 0,
          alignment: 'left',
          title: 'Name',
          weight: '600',
          width: '15rem'
        },
        {
          columnNumber: 1,
          alignment: 'left',
          title: 'ID',
          width: '5rem'
        },
        {
          columnNumber: 2,
          alignment: 'left',
          title: 'Description',
          width: '25rem'
        }
      ],
      payload: []
    };
    this.selectedActions.map(data => {
      const tmp: GenericPayloadModel = {
        key: 'name',
        type: GenericPayloadType.text,
        label: data.name,
        cols: [
          {
            key: 'id',
            label: 'ID',
            value: data.id,
            type: GenericPayloadType.text
          }, {
            key: 'description',
            label: 'Description',
            value: data.description,
            type: GenericPayloadType.text
          }
        ]
      };
      this.actionInfo?.payload.push(tmp);
    });
  }

  @Output() close: EventEmitter<string> = new EventEmitter<string>();

  constructor(private readonly actionService: ActionService) { }

  ngOnInit(): void { }

  cancel(value: any): void {
    this.close.emit('cancelled');
  }

  submit(): void {
    this.gather();
    console.dir(this.parcel);
    if (this.parcel.length > 0) {
      this.actionService.archiveAction(this.parcel).subscribe(res => {
        console.dir(res);
        this.done = true;
      });
    }
  }

  onComplete(): void {
    this.close.emit('archived');
  }

  gather(): void {
    this.selectedActions.map(data => {
      this.parcel.push(data.id);
    });
  }

}
